import type { SofiaProposedAction } from "../model/types"

export function PythonMetricActionDetails({
  proposal,
}: {
  proposal: SofiaProposedAction
}) {
  if (
    (proposal.kind === "create_python_metric_draft" ||
      proposal.kind === "save_python_analysis_metric") &&
    typeof proposal.args.source === "string"
  ) {
    return (
      <details className="mt-3 text-xs" open>
        <summary className="cursor-pointer font-medium text-coval-text">
          Python source
        </summary>
        {proposal.args.output_type === "number" ||
        proposal.args.output_type === "boolean" ? (
          <p className="mt-2 text-coval-text-muted">
            Output:{" "}
            {proposal.args.output_type === "number" ? "Number" : "Boolean"}
          </p>
        ) : null}
        {proposal.kind === "create_python_metric_draft" ? (
          <p className="mt-2 text-coval-text-muted">
            Inputs:{" "}
            {[
              "conversation",
              proposal.args.audio === true ? "original audio" : null,
              proposal.args.traces === true ? "traces" : null,
              ...(Array.isArray(proposal.args.frame_tables)
                ? proposal.args.frame_tables.filter(
                    (value): value is string => typeof value === "string",
                  )
                : []),
            ]
              .filter(Boolean)
              .join(", ")}
          </p>
        ) : null}
        <pre className="mt-2 max-h-80 overflow-auto rounded border border-coval-border bg-surface-default p-3 text-coval-text">
          <code>{proposal.args.source}</code>
        </pre>
        <p className="mt-2 text-coval-text-muted">
          {proposal.kind === "save_python_analysis_metric"
            ? "Saves the exact computation already tested on this recording. No additional test is required; testing more recordings is optional."
            : "Creates a draft. Testing and publishing each require confirmation."}
        </p>
      </details>
    )
  }
  const detail =
    proposal.kind === "preview_python_metric"
      ? "Runs this draft on the selected conversation. A queued preview is not a completed test."
      : proposal.kind === "cancel_python_metric_preview"
        ? "Cancels a pending preview and discards its result. Completed previews stay unchanged; a running evaluation may finish in the background."
        : proposal.kind === "publish_python_metric"
          ? "Publishes only this fingerprint and its successful preview evidence. Changed code must be tested again."
          : null
  return detail ? (
    <p className="mt-2 text-xs text-coval-text-muted">{detail}</p>
  ) : null
}
